var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, DropdownButton, Image, Text, Tooltip, } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import classnames from 'classnames';
import moment from 'moment-timezone';
import { Component } from 'react';
import { Link } from 'react-router-dom';
import { analytics } from 'app/utils/segment';
import { CommandKeybindingsTooltipContent } from 'components/commandKeybindingsTooltipContent';
import ComposeEmailHelper from '../../../shared/composeEmail/helper/ComposeEmailHelper';
import { TopbarButton } from '../topbarButton/';
import styles from './emailTopbarButton.module.scss';
import ComposeEmailNoDraftImage from './no-conversations.png';
export class EmailTopbarButton extends Component {
    componentDidMount() {
        this.props.composeEmailGetDrafts();
        this.props.composeEmailGetAllFrom();
    }
    onDropdownToggle(isOpen) {
        if (isOpen === true) {
            this.props.composeEmailGetDrafts();
            analytics.topbarEmailOpened();
        }
    }
    openCompose(draft) {
        ComposeEmailHelper.focus();
        this.props.composeEmailOpenModal(draft);
    }
    render() {
        const { className } = this.props;
        let draftRender;
        let showNotificationIndicator = false;
        let noEmailIntegration;
        let restOftotalDraftsNumber = 0;
        let moreLayout;
        const rootClass = classnames({
            [styles.root]: styles.root,
        }, className);
        if (this.props.fromEmails.length === 0 &&
            this.props.meta.getAllFrom === 'succeeded') {
            noEmailIntegration = (_jsxs("li", Object.assign({ className: styles.empty + ' text-center' }, { children: ["No email integration found", ' ', this.props.profile.is_admin === true && (_jsx(Link, Object.assign({ className: "btn btn-link btn-xs ", to: "/settings/email" }, { children: "Create one in email settings" })))] })));
        }
        const listDraft = (draft, index) => {
            return (_jsxs("li", Object.assign({ className: styles.item }, { children: [_jsxs("div", Object.assign({ className: styles.draftItemHolder + ' pull-left' }, { children: [_jsx("h4", Object.assign({ className: styles.title }, { children: _jsxs("em", { children: [draft.subject !== undefined ? draft.subject : 'unknown', ' ', "(Unsent draft)"] }) })), _jsx("h6", Object.assign({ className: styles.time }, { children: moment(draft.timestamp).fromNow() }))] })), _jsxs("div", Object.assign({ className: styles.draftActionsHolder }, { children: [_jsx("button", Object.assign({ type: "button", className: styles.view + ' btn', onClick: () => {
                                    this.openCompose({ initialValues: draft });
                                } }, { children: "View" })), _jsx("button", Object.assign({ type: "button", className: styles.remove + ' btn', onClick: () => this.props.composeEmailRemoveDraft({
                                    timestamp: draft.timestamp,
                                }) }, { children: "Remove" }))] }))] }), index));
        };
        if (this.props.emailDrafts.length > 0) {
            showNotificationIndicator = true;
            const draftsArray = [...this.props.emailDrafts];
            if (draftsArray.length > 5) {
                draftRender = draftsArray.slice(0, 5).map(listDraft);
            }
            else {
                draftRender = draftsArray.map(listDraft);
            }
        }
        else if (this.props.emailDrafts.length === 0 &&
            (this.props.meta.getDrafts === 'loading' ||
                this.props.meta.removeDrafts === 'loading')) {
            draftRender = _jsx("li", Object.assign({ className: styles.empty }, { children: "loading..." }));
        }
        else if (this.props.emailDrafts.length === 0) {
            draftRender = (_jsxs("div", Object.assign({ className: styles.empty }, { children: [_jsx(Image, { src: ComposeEmailNoDraftImage, className: styles.emptyImage, alt: "No draft email" }), _jsx("h3", Object.assign({ className: styles.heading }, { children: "No drafts here" }))] })));
        }
        if (this.props.emailDrafts.length > 5) {
            restOftotalDraftsNumber = this.props.emailDrafts.length - 5;
        }
        if (this.props.emailDrafts.length > 0) {
            moreLayout = (_jsx("li", Object.assign({ role: "more", className: styles.more }, { children: _jsxs(Link, Object.assign({ to: "/drafts" }, { children: ["See all drafts", ' ', restOftotalDraftsNumber > 0
                            ? `(${restOftotalDraftsNumber} more)`
                            : this.props.emailDrafts.length > 0
                                ? `(${this.props.emailDrafts.length})`
                                : ''] })) })));
        }
        const DropdownContent = (_jsxs("ul", Object.assign({ className: classnames({
                [styles.content]: true,
                [styles.fullWidthContent]: this.props.alignCenter,
            }) }, { children: [_jsx("li", Object.assign({ role: "headline", className: styles.headline }, { children: _jsx(Text.Heading, { children: "Email" }) })), _jsx("li", { role: "separator", className: styles.divider }), draftRender, noEmailIntegration, _jsx("li", Object.assign({ role: "more", className: styles.more }, { children: _jsx(Tooltip, Object.assign({ content: this.props.browser.os === 'Mac OS'
                            ? 'New email Ctrl+⌥+N'
                            : 'New email Ctrl+Alt+N', dark: true }, { children: _jsx(Button, Object.assign({ type: "button", variant: "secondary", style: { width: '100%' }, onClick: () => this.openCompose() }, { children: "Compose" })) })) })), _jsx("li", { role: "separator", className: styles.divider }), moreLayout] })));
        const tooltip = (_jsx(CommandKeybindingsTooltipContent, Object.assign({ commandName: "conversation:composeNewEmail" }, { children: "New e-mail" })));
        return (_jsx(DropdownButton, Object.assign({ icon: "mail", className: rootClass, onToggle: this.onDropdownToggle, noArrow: true, noStyle: true, dropdownProps: {
                closeOnBlur: false,
                className: classnames({
                    [styles.dropdownMenuAlignCenter]: this.props.alignCenter,
                }),
            }, dropdown: DropdownContent, "data-testid": "compose-email-dropdown" }, { children: _jsx(TopbarButton, { icon: "mail", tooltip: tooltip, notificationIndicatorTooltip: showNotificationIndicator
                    ? 'You have unused email drafts'
                    : undefined, notificationIndicatorClassName: styles.notificationIndicator, showNotificationIndicator: showNotificationIndicator }) })));
    }
}
__decorate([
    boundMethod
], EmailTopbarButton.prototype, "onDropdownToggle", null);
__decorate([
    boundMethod
], EmailTopbarButton.prototype, "openCompose", null);
